/* eslint-disable no-unused-vars */
/*
Format: -
{
    "type":"ActionBar",
    "align":"left",
    "buttons":[
        {"label":"Specification", "click":"handleShowSpec"},
        {"label":"Formula", "click":"handleShowFormula"},
        {"label":"Process", "click":"handleShowProcess"}
    ]
}

Property "click" call function from app.handlers[] which defined in app root
*/

import React, { useCallback, useEffect, useRef, useState } from 'react';

export function TabBar(props) {
  const { em, app } = props;

  const activeName = em && em.active && app && app[em.active] ? app[em.active] : '';
  const align = em && em.align && em.align !== '' ? em.align : 'center';
  return (
    <div className="row mb-2 tab-bar">
      <div className={`col-12 text-${align}`}>
        {em &&
          em.buttons &&
          em.buttons.map((t, i) => {
            return (
              <button
                name={t.name}
                type="button"
                key={i}
                onClick={t.click && app.handlers && app.handlers[t.click] ? app.handlers[t.click] : undefined}
                className={'btn btn-sm mx-1 ' + (t.name === activeName ? 'active' : '')}
              >
                {t.label}
              </button>
            );
          })}
      </div>
    </div>
  );
}
